export default {
	loading: false,
	goodsTypes: []
};